import {
  createStyles,
  makeStyles,
  withStyles,
  Theme
} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

// スタイル
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '80%',
      maxHeight: '90vh',
      overflowY: 'auto',
      position: 'relative'
    },
    deleteModalHeader: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maginTop: 24
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%'
    },
    sendEmailPaper: {
      // モーダル内部（メール送信モーダル）
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '40%'
    },
    modalTitle: {
      // モーダル上部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 20,
      borderBottom: '1px solid #cfcfcf'
    },
    modalLeft: {
      // モーダル左側
      padding: 10
    },
    modalRight: {
      // モーダル右側
      padding: 10,
      paddingLeft: 30
    },
    pictureArea: {
      // モーダル右側(写真)
      padding: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: '20px'
    },
    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },
    tableHead: {
      //入力フォームラベル
      width: '100px'
    },
    tableBody: {
      //入力フォーム右列
      minWidth: 240,
      width: '100%',
      marginBottom: 5
    },
    description: {
      //入力フォームラベル
      width: '100%'
    },
    selectBoxStyle: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      border: '1px solid #ced4da',
      fontSize: 14,
      padding: '10px 26px 10px 12px',
      height: 40,
      width: '100%',
      borderRadius: 4,
      color: '#52555f',
      marginBottom: 5
    },
    width100: {
      width: '100%'
    },
    copyStateMessage: {
      // リンクURLコピーの成否メッセージ
      position: 'absolute',
      left: 8,
      bottom: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: 300,
      padding: '12px 24px',
      borderRadius: 8,
      color: 'white',
      backgroundColor: 'black',
      fontSize: 14,
      opacity: 0.8
    },
    pictureEditIcon: {
      // 共有先ページの写真編集アイコン
      position: 'absolute',
      bottom: 10,
      right: 10,
      width: 30,
      height: 30,
      borderRadius: '50%',
      backgroundColor: '#fff',
      opacity: 0.7,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    customTextField: {
      '& .MuiInputBase-root': {
        height: 40,
        fontSize: 14,
        padding: '10px 26px 10px 12px'
      },
      '& .MuiOutlinedInput-input': {
        height: 'calc(100% - 20px)', // 入力部分の高さをフィールドの高さから計算
        fontSize: 14,
        padding: '10px 26px 10px 12px'
      }
    },
    navButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      zIndex: 1000,
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.9)'
      }
    },
    navLeft: {
      left: 10
    },
    navRight: {
      right: 10
    }
  })
);

//詳細モーダルダウンロード・削除ボタン
export const ModalInnerButton = withStyles(() => ({
  root: {
    color: '#fff',
    background: '#52555f',
    width: 160,
    height: 50,
    marginBottom: 12,
    '&:hover': {
      background: '#52555f',
      boxShadow: 3
    }
  }
}))(Button);

//詳細モーダル送信（更新）ボタン
export const ModalSubmitButton = withStyles(() => ({
  root: {
    backgroundColor: '#007dff',
    color: '#fff',
    width: 200,
    height: 48,
    '&:hover': {
      backgroundColor: '#2691ff',
      boxShadow: 3
    }
  }
}))(Button);

//詳細モーダル下部キャンセルボタン
export const ModalCancelButton = withStyles(() => ({
  root: {
    backgroundColor: '#bdbdbd',
    color: '#fff',
    marginRight: 36,
    width: 200,
    height: 48,
    '&:hover': {
      backgroundColor: '#cccccc',
      boxShadow: 3
    }
  }
}))(Button);

//詳細モーダル削除ボタン
export const ModalDeleteButton = withStyles(() => ({
  root: {
    backgroundColor: '#ff1212',
    color: '#fff',
    width: 200,
    height: 48,
    '&:hover': {
      backgroundColor: '#ff4444',
      boxShadow: 3
    }
  }
}))(Button);

// 資料・写真・工程表への遷移ボタン
export const ListButton = withStyles(() => ({
  root: {
    backgroundColor: '#007dff',
    color: '#fff',
    width: 100,
    height: 40,
    '&:hover': {
      backgroundColor: '#2691ff',
      boxShadow: 3
    }
  }
}))(Button);

// リンク送信ボタン
export const LinkSendButton = withStyles(() => ({
  root: {
    backgroundColor: '#52555f',
    color: '#fff',
    width: 140,
    height: 40,
    '&:hover': {
      backgroundColor: '#777A82',
      boxShadow: 3
    }
  }
}))(Button);

// リンクコピーボタン
export const LinkCopyButton = withStyles(() => ({
  root: {
    color: '#666666',
    border: '1px solid #666666',
    marginRight: 8,
    width: 140,
    height: 40,
    '&:hover': {
      backgroundColor: '#D5D5D5',
      boxShadow: 3
    }
  }
}))(Button);

// リンク送信ボタン
export const OpenDocumentButton = withStyles(() => ({
  root: {
    backgroundColor: '#52555f',
    color: '#fff',
    width: 140,
    height: 40,
    '&:hover': {
      backgroundColor: '#777A82',
      boxShadow: 3
    }
  }
}))(Button);
